import { Auth0Provider } from '@auth0/auth0-react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import { config } from './config'
import { DemoStage } from './dev/DemoStage'
import { initEmbed } from './embed'

// Attach the dashboard-embed listener BEFORE render so the parent's context
// message can never race past us. No-op unless loaded with ?embedded=1.
initEmbed()

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
})

const root = document.getElementById('root')
if (!root) throw new Error('root element missing')

const isDemo = new URLSearchParams(window.location.search).has('demo')

createRoot(root).render(
  isDemo ? (
    <StrictMode>
      <DemoStage />
    </StrictMode>
  ) : (
    <StrictMode>
      <Auth0Provider
        domain={config.auth0Domain}
        clientId={config.auth0ClientId}
        authorizationParams={{
          audience: config.auth0Audience,
          redirect_uri: window.location.origin,
          scope: 'openid profile email offline_access read:current_user',
        }}
        cacheLocation="localstorage"
        useRefreshTokens={true}
        useRefreshTokensFallback={true}
      >
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </Auth0Provider>
    </StrictMode>
  ),
)
